/**
 * Feature flags convention: go/frontend-feature-flags
 */

import { ff } from '@atlassian/jira-feature-flagging';

export const isFilterIssueChangedEvents = () =>
	ff('filter-issue-changed-connect-app-events-to-non-dialogs');

export const isComingFromSyntheticTest = () => ff('issue.details.forge-ui-synthetic-check', false);
